


const Header = () => {
    return (
        <header>
            <h1>Typing Speed Test</h1>
        </header>
    )
}

export default Header
